import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Login,
  },
  {
    path: "/Admin",
    name: "admin",
    component: () => import("../views/DashRoles/AdminViews/Admin.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
    },
  },
  {
    path: "/Nouveaux-Documents",
    name: "Documents",
    component: () => import("../views/DashRoles/NewDocuments/NewDocuments.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Documents-en-cours",
    name: "cours",
    component: () =>
      import("../views/DashRoles/PendingDocuments/PendingDocuments.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Documents-archives",
    name: "archives",
    component: () =>
      import("../views/DashRoles/PinnedDocuments/PinnedDocuments.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Documents-affectes",
    name: "affectes",
    component: () =>
      import("../views/DashRoles/AffectedDocuments/AffectedDocuments.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
    },
  },
  {
    path: "/Nouveau-dossier",
    name: "nouveau",
    component: () => import("../views/DashRoles/NewFolder/NewFolder.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("token") == null) {
      next({
        path: "/",
        params: { nextUrl: to.fullPath },
      });
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      if (to.matched.some((record) => record.meta.isAdmin)) {
        if (
          user.role === "admin" ||
          user.role === "dg" ||
          user.role === "assistantDg"
        ) {
          next();
        } else {
          next({ name: "Home" });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
